export const pageHeader2023Gql = /* GraphQL */ `... on landingPageContent2023_pageHeader_BlockType {
  typeHandle
  textAlignment
  eyebrow
  pageTitle
  subtitle
  text
  backgroundOverlayOpacity
  theme
  callToAction {
    ariaLabel
    customText
    target
    text
    title
    type
    url
  }
  backgroundImage {
    __typename
    ... on images_Asset {
      lpImageTextUncropped {
        srcset
        srcWebp
      }
    }
    ... on videoUploads_Asset {
      url
    }
  }
}`;
